import { Group } from '@app/core/models';
import { createAction, props } from '@ngrx/store';
import { AcademicState } from './academic.state';

export const UpdateStateReducer = createAction('[Academic] UpdateStateReducer', props<{ value: AcademicState }>());
export const SelectGroupReducer = createAction('[Academic] SelectGroupReducer', props<{ group: Group }>());
export const SelectPeriodReducer = createAction('[Academic] SelectPeriodReducer', props<{ period_id: number }>());
